/** Yields the MQTT worker to be used by the MQTT services */
export const getMqttWorkerRef = (): Worker => {
    /**
     * The way parcel works when setting up workers is to
     * identify a valid URL to a file, and a worker type
     *
     * All of them need to be in the same place in order
     * for this worker to be properly created
     */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return new Worker(new URL('./MqttWorker.ts', import.meta.url), { type: 'module' })
}
